import { render, staticRenderFns } from "./vfooter.vue?vue&type=template&id=426b4ff3&scoped=true&"
import script from "./vfooter.vue?vue&type=script&lang=js&"
export * from "./vfooter.vue?vue&type=script&lang=js&"
import style0 from "./vfooter.vue?vue&type=style&index=0&id=426b4ff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b4ff3",
  null
  
)

export default component.exports